<template>
    <div class="app">
        <div class="login">
            <div v-if="mobile" class="bind_tip">
                {{$t('l.bind_tip')}}
            </div>
            <Form :rules="bindRules" ref="bind" :model="bind">
                <FormItem :label="$t('l.old_mobile')" v-if="mobile">
                    <Input prefix="ios-call" v-model="mobile" readonly/>
                </FormItem>
                <FormItem :label="mobile?$t('l.new_mobile'):$t('l.mobile')" prop="mobile">
                    <Input prefix="ios-call" v-model="bind.mobile" :placeholder="$t('l.remark3')"/>
                </FormItem>
                <FormItem :label="$t('l.captcha')" prop="captcha">
                    <Input prefix="ios-lock" v-model="bind.captcha" :placeholder="$t('l.remark4')"/>
                    <Button :loading="loading"
                            :style="{backgroundColor:start!=$t('l.get_captcha')?'#aaa':'#2a9fff'}"
                            :disabled="start!=$t('l.get_captcha')" class="button-captcha"
                            type="info"
                            long @click="getCaptcha">{{start}}
                    </Button>
                </FormItem>
                <FormItem>
                    <Button @click="confirm('bind')" :loading="bind.loading" type="primary">{{$t('l.binding')}}</Button>
                </FormItem>
            </Form>
        </div>

        <lg-modal :title="modal.title" :show="modal.show"
                  :showCancel="false" :confirmText="$t('l.confirm')" @on-submit="onSubmitJump()">
            <div style="text-align: center;font-weight: bold;font-size: 20px;">
                <img src="../../../public/images/wx/success.png" style="width: 60%"/>
                <div>{{$t('l.bind_success')}}</div>
            </div>
        </lg-modal>
    </div>
</template>

<script>
    import util from '@/libs/util.js';
    import lgModal from "../my-components/lg-modal";

    export default {
        name: "page-bind",
        components: {lgModal},
        data() {
            return {
                bind: {
                    mobile: '',
                    captcha: '',
                    loading: false
                },
                start: this.$t('l.get_captcha'),
                loading: false,
                openid: '',
                mobile: '',
                source: '',
                modal: {
                    title: this.$t('l.prompt'),
                    show: false,
                }
            }
        },
        methods: {
            onSubmitJump() {
                window.location.href = "/#/wx/" + this.source + "?openid=" + this.openid;
            },
            confirm(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.bind.loading = true;
                        var param = {
                            openid: this.openid,
                            mobile: this.bind.mobile,
                            captcha: this.bind.captcha,
                            oldMobile: this.mobile,
                        };
                        util.ajax.post('/wx/bind/bindMobile', param).then((res) => {
                            this.bind.loading = false;
                            if (!res.code) {
                                this.modal.show = true;
                            }
                        });
                    }
                });
            },
            getCaptcha() {
                if (!this.bind.mobile) {
                    this.$Message.error(this.$t('l.remark3'));
                    return;
                }
                if (this.bind.mobile && this.mobile && this.mobile == this.bind.mobile) {
                    this.$Message.error(this.$t('l.same_mobile'));
                    return;
                }
                this.loading = true;
                util.ajax.get('/wx/bind/captcha', {
                    params: {
                        data: {
                            company: "【" + this.$t('l.dty_platform') + "】",
                            mobile: this.bind.mobile,
                            language: "zh"
                        }
                    }
                }).then(res => {
                    this.loading = false;
                    if (!res.code) {
                        this.start = 60;
                        this.$Message.success(this.$t('l.hint4'));
                        var timer = setInterval(() => {
                            if (this.start == 0) {
                                clearInterval(timer);
                                this.start = this.$t('l.get_captcha');
                            } else {
                                this.start--;
                            }
                        }, 1000);
                    }
                })
            },
        },
        computed: {
            bindRules() {
                return {
                    mobile: [{required: true, message: this.$t('l.hint2'), trigger: 'blur'}],
                    captcha: [{required: true, message: this.$t('l.hint3'), trigger: 'blur'}]
                }
            },
        },
        mounted: function () {
            this.openid = this.$route.query.openId;
            this.mobile = this.$route.query.mobile;
            this.source = this.$route.query.source;
        },
    }
</script>


<style scoped>
    .app {
        height: 100%;
        width: 100%;
        padding: 15px;
        background-image: url("../../../public/images/wx/qr_top.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-color: #f5f5f5;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .login {
        width: 90%;
        box-shadow: 0 0 7px #2a9fff;
        border-radius: 12px;
        background: white;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 5%;
        position: relative;
    }

    .ivu-form-item {
        width: 90%;
        margin: 10% 0 5% 5%;
        display: inline-grid;
    }

    ::v-deep .ivu-form-item-label {
        text-align: left;
        padding: 6px 12px 6px 0;
    }

    ::v-deep .ivu-input-prefix i, ::v-deep .ivu-input-suffix i {
        line-height: 26px;
    }

    .ivu-btn {
        padding: 1.7px 7px 1.7px;
    }

    .theme-default .ivu-btn-primary {
        width: 100%;
    }

    .bind_tip {
        position: absolute;
        top: -40px;
        color: #DC143C;
        font-weight: bold;
        font-size: 18px;
    }
</style>